import { apiPost, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Event Types Service (Car Types)
 * Handles car type management operations
 */
const EventTypesService = {
  /**
   * Get all event types (car types)
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllEventTypes(filters) {
    return apiPost(API_ENDPOINTS.EVENT_TYPES.GET_ALL, filters);
  },

  /**
   * Create new event type (car type)
   * @param {Object} eventTypeData - Event type creation data
   * @returns {Promise} API response
   */
  async createEventTypes(eventTypeData) {
    return apiPost(API_ENDPOINTS.EVENT_TYPES.CREATE, eventTypeData);
  },

  /**
   * Update event type (car type)
   * @param {Object} eventTypeData - Event type update data
   * @returns {Promise} API response
   */
  async updateEvent(eventTypeData) {
    return apiPost(API_ENDPOINTS.EVENT_TYPES.UPDATE, eventTypeData);
  },

  /**
   * Delete event type (car type)
   * @param {Object} eventTypeData - Event type deletion data
   * @returns {Promise} API response
   */
  async deleteCategoryEvent(eventTypeData) {
    return apiPost(API_ENDPOINTS.EVENT_TYPES.DELETE, eventTypeData);
  },
};

export default EventTypesService;
